import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';

function Notes() {
    return (
        <>
        <Header/>
        <Footer/>
        </>
    )
}

export default Notes;